/**
 * 分享模板：枚举与文案映射（列表页 / 详情页共用）
 */
// 模板类型：1-跑后模板（当前仅此一种）
export const TEMPLATE_TYPE_OPTIONS = [{ value: 1, label: "跑后模板" }];

// 使用类型：1-永久免费，2-限时免费，3-会员免费（本期暂不启用 3）
export const USE_TYPE_OPTIONS = [
  { value: 1, label: "永久免费" },
  { value: 2, label: "限时免费" },
];

// 状态：0-停用，1-启用
export const STATUS_OPTIONS = [
  { value: 1, label: "已启用" },
  { value: 0, label: "已停用" },
];

export function getTemplateTypeText(value) {
  const found = TEMPLATE_TYPE_OPTIONS.find((item) => item.value === value);
  return found ? found.label : "-";
}

export function getUseTypeText(value) {
  const found = USE_TYPE_OPTIONS.find((item) => item.value === value);
  return found ? found.label : "-";
}

export function getStatusText(value) {
  const found = STATUS_OPTIONS.find((item) => item.value === value);
  return found ? found.label : "-";
}

/**
 * 列表排序映射：el-table 的 prop + order -> 后端 orderType
 * 0-展示排序升序，1-展示排序降序，2-创建时间升序，3-创建时间降序，4-修改时间升序，5-修改时间降序
 */
export const ORDER_TYPE_MAP = {
  sort: { ascending: 0, descending: 1 },
  createAt: { ascending: 2, descending: 3 },
  updateAt: { ascending: 4, descending: 5 },
};

export function getOrderType(prop, order) {
  if (!prop || !order) return "";
  const map = ORDER_TYPE_MAP[prop];
  if (!map) return "";
  const val = map[order];
  return val === undefined ? "" : val;
}



// WEBPACK FOOTER //
// ./src/views/OperationManage/UserAdminister/ShareTemplate/constants.js